<arb-header></arb-header>
<div class="content">
  <router-outlet></router-outlet>
</div>